export function initializeShareToSocial() {
    const linkedIn = document.getElementById('share-linkedin');
    const x = document.getElementById('share-x');
    const telegram = document.getElementById('share-telegram');
    const email = document.getElementById('share-email');

    // Exit if none of the share buttons exist on this page
    if (!linkedIn && !x && !telegram && !email) return;

    const url = encodeURIComponent(window.location.href);
    const title = encodeURIComponent(document.title || '');
    const body = encodeURIComponent(`${document.title}\n\n${window.location.href}`);

    if (linkedIn) linkedIn.href = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
    if (x) x.href = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
    if (telegram) telegram.href = `https://t.me/share/url?url=${url}&text=${title}`;
    if (email) email.href = `mailto:?subject=${title}&body=${body}`;
}